import { useQuery } from "@tanstack/react-query";
import { dashboardApi } from "@/api/dashboard.api";
import { useAuthStore } from "@/store/auth.store";

export function useDashboardSummary() {
  return useQuery({
    queryKey: ["dashboard", "summary"],
    queryFn: dashboardApi.getSummary,
  });
}

export function useComplaintTrend(range = "30d") {
  return useQuery({
    queryKey: ["dashboard", "trend", range],
    queryFn: () => dashboardApi.getComplaintTrend(range),
  });
}

export function useEmployeePerformance() {
  const role = useAuthStore((s) => s.user?.role);
  return useQuery({
    queryKey: ["dashboard", "employee-performance"],
    queryFn: dashboardApi.getEmployeePerformance,
    enabled: role === "ADMIN",
  });
}

export function useNotifications() {
  return useQuery({
    queryKey: ["dashboard", "notifications"],
    queryFn: dashboardApi.getNotifications,
    refetchInterval: 60_000, // keep the bell/notification panel reasonably fresh
  });
}
